import React from 'react'
import styled from 'styled-components'
import Link, { handleHoverStyleLinkType, handleStyleLinkType } from 'ui/Link'
import { TLocaleCode } from 'constants/locales'
interface PreviewBlockProps {
  title: string
  preview: string
  text: string
  isButton: boolean
  buttonLabel: string
  href: string
  isGridArea?: boolean
  isWhite?: boolean
  includeLangsArr?: TLocaleCode[]
}

const PreviewBlock: React.FC<PreviewBlockProps> = props => {
  const {
    title,
    preview,
    text,
    isButton = false,
    buttonLabel = '',
    href = '',
    isGridArea,
    isWhite,
    includeLangsArr,
  } = props
  return (
    <Container $isGridArea={isGridArea} $isWhite={isWhite}>
      <ContentWrapper>
        <Title $isWhite={isWhite}>{title}</Title>
        <Preview src={preview} alt={text} />
        <Text $isWhite={isWhite}>{text}</Text>
      </ContentWrapper>
      {isButton ? (
        <StyledLink type={'tertiary'} to={href} includeLangsArr={includeLangsArr}>
          {buttonLabel}
        </StyledLink>
      ) : null}
    </Container>
  )
}

export default PreviewBlock

const Container = styled.section<{ $isGridArea?: boolean; $isWhite?: boolean }>`
  background: ${({ $isWhite }) =>
    $isWhite
      ? 'linear-gradient(0deg, #F3F7FD, #F3F7FD), #123482'
      : 'linear-gradient(180deg, #1743a7 0%, #1743a7 100%)'};
  padding: 1.75rem;
  grid-area: ${({ $isGridArea }) => ($isGridArea ? 'block' : 'auto')};
  border-radius: 0.5rem 0 0 0.5rem;
`

const ContentWrapper = styled.div`
  margin: 0 0.5rem;
  text-align: start;
`

const Title = styled.h4<{ $isWhite?: boolean }>`
  color: ${({ theme: { colors }, $isWhite }) =>
    $isWhite ? colors.newLightColor.softNavy : colors.newLightColor.white};
  font-weight: 600;
  font-size: 1rem;
  text-align: start;

  margin-bottom: 1.375rem;
`

const Preview = styled.img`
  width: 184px;
  height: 184px;
  border-radius: 4px;
  text-align: start;
`

const Text = styled.p<{ $isWhite?: boolean }>`
  font-size: 0.875rem;
  letter-spacing: 0.02em;
  font-weight: 400;
  text-align: start;
  color: ${({ theme: { colors }, $isWhite }) => ($isWhite ? colors.newLightColor.softNavy : colors.lightBlue)};
  margin: 0.75rem 0;
  line-height: 21px;
  text-align: center;

  opacity: ${({ $isWhite }) => ($isWhite ? '0.8' : '1')};
`

const StyledLink = styled(Link)`
  width: 200px;
  margin: 0.25rem auto;
  text-transform: none;
  padding: 9px;

  ${handleStyleLinkType('tertiary')}
  &:hover {
    ${handleHoverStyleLinkType('tertiary')}
  }
`
